import { serverResponse } from 'app'

export * from './delete'
export * from './fetch'
export * from './restore'

export const getTeamLineupsInitialState = () =>
  serverResponse({
    fields: {},
    serverResponse: {},
  })

export const TEAMS_TEAM_LINEUPS_RESET = 'TEAMS_TEAM_LINEUPS_RESET'

export const teamLineupsReset = () => ({
  payload: null,
  type: TEAMS_TEAM_LINEUPS_RESET,
})
